// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { signInOverlayStyles } from "@insite/content-library/Pages/SignInOverlay";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { IconWrapper } from "@insite/mobius/Icon";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { buttonTransparent } from "@west/XDL/PreStyle/button";
import { color, hideElement, mergeWithCss, xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

signInOverlayStyles.drawer = {
    size: 400,
    closeButtonProps: {
        mergeCss: true,
        color: "common.background",
        buttonType: "solid",
        shape: "pill",
        css: css`
            border: 0;
            padding: 0 5px;
            margin-right: 15px;
            ${buttonTransparent}
            &:hover ${IconWrapper} {
                color: ${color("common.ui8")};
            }
        `,
    },
    cssOverrides: {
        drawerTitle: css`
            background: ${getColor("common.background")};
        `,
        drawerBody: css`
            background: ${getColor("common.background")};
            ${xScreen("lt", "sm")} {
                && {
                    width: 100%;
                }
            }
        `,
    },
};
